import { useEffect, useState } from 'react'

import { Milliseconds } from '@/utils/milliseconds'

import { Text } from './text'

function Component({ updatedAt }: { updatedAt: Date | string | number }) {
  const [time, setTime] = useState(0)

  function calculate() {
    const nowTime = new Date().getTime()
    const updatedTime =
      updatedAt instanceof Date
        ? updatedAt.getTime()
        : new Date(updatedAt).getTime()

    const time = Math.floor(
      (nowTime - Math.max(updatedTime, nowTime)) / Milliseconds({ minutes: 1 }),
    )

    setTime(time)
  }

  useEffect(() => {
    calculate()
    const interval = setInterval(calculate, Milliseconds({ seconds: 30 }))
    return () => clearInterval(interval)
  }, [updatedAt])

  return (
    <Text asChild variant="soft" className="text-xs">
      <span>Atualizado {time > 0 ? 'a ' + time + ' min(s)' : 'agora'}</span>
    </Text>
  )
}

export { Component as UpdatedAtLabel }
